import React from "react";

import {
  ValueField,
  ZoomCoefficientValueField,
} from "../../ValueFields/ValueFields";
import { Heading3 } from "../../Headings/Headings";

const PsoriasisCalculatedResults = (props) => {
  const { calculationProgress, psoriasisCalculationData } = props;

  const { calculationSuccessful = false } = calculationProgress;

  const {
    classificationZC = 0.5,
    semanticZC = 0.5,
    erythema = 0,
    induration = 0,
    desquamation = 0,
    overallAffected = 0,
  } = psoriasisCalculationData;

  return (
    <div
      className="flex flex-col w-full overflow-hidden Xbg-red-500"
      style={
        calculationSuccessful
          ? { height: "100%" }
          : { height: "0", padding: "0", margin: "0" }
      }
    >
      <div className="py-2" />

      <Heading3 headingText={"Calculation Results"} />

      <div className="py-1" />
      <div className="overflow-x-scroll">
        <div className="flex flex-col w-full min-w-[50rem]">
          <div className="flex flex-row w-full">
            <ValueField value={""} />
            <div className="px-1" />
            <ValueField value={"Erythema"} />
            <div className="px-1" />
            <ValueField value={"Induration"} />
            <div className="px-1" />
            <ValueField value={"Desquamation"} />
            <div className="px-1" />
            <ValueField value={"Affected"} />
          </div>
          <div className="py-1" />
          <div className="flex flex-row w-full">
            <ValueField value={"Photo"} />

            <div className="px-1" />
            <ValueField value={erythema} />
            <div className="px-1" />
            <ValueField value={induration} />
            <div className="px-1" />
            <ValueField value={desquamation} />
            <div className="px-1" />
            <ValueField value={Number(overallAffected).toFixed(2)} />
          </div>

          <div className="py-2" />
          <div className="flex flex-row w-full">
            <ZoomCoefficientValueField
              name={"Semantic Zoom Coefficient"}
              value={Number(semanticZC).toFixed(2)}
            />
            <div className="px-1" />
            <ZoomCoefficientValueField
              name={"Classification Zoom Coefficient"}
              value={Number(classificationZC).toFixed(2)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PsoriasisCalculatedResults;
